export enum Routes {
  START = "/",
  MAIN = "/main-page",
  CHECKOUT = "/checkout",
  AGE_VERIFICATION_PAGE = "/age-verification",
  SUCCESS = "/success",

  // Pickup module
  PICK_UP_TIME_SLOT = "/pickup-time-slot",
  YOUR_INFO = "/your-info",
}
